export const SEND_REQUEST_PASSWORD_RESET = "SEND_REQUEST_PASSWORD_RESET";
export const VERIFICATION_OF_EMAIL = "VERIFICATION_OF_EMAIL";
export const RESEND_EMAIL_TOKEN = "RESEND_EMAIL_TOKEN";
export const RESET_PASSWORD = "RESET_PASSWORD";
